<!-- TEMPLATE -->
<template>
  <div>
    <v-alert
      v-model="alertSuccess"
      dismissible
      border="left"
      elevation="2"
      dense
      text
      type="success"
      icon="mdi-checkbox-marked-circle"
    >
      {{ alertText }}
    </v-alert>
    <v-alert
      v-model="alertError"
      dismissible
      dense
      text
      type="error"
      border="left"
      elevation="2"
      icon="mdi-alert-circle"
    >
      {{ alertText }}
    </v-alert>
  </div>
</template>


<!-- SCRIPT -->
<script>
export default {
  name: "ShowAlertNotification",
  data: function () {
    return {
      alertSuccess: false,
      alertError: false,
      alertText: "",
    };
  },
  created() {},
  mounted() {},
  computed: {},
  actions: {
    notification({ commit }) {
      this.$root.$store.commit("notification");
    },
  },
  methods: {
    doSomething: function () {
      alert(1);
    },
  },
  filters: {},
  components: {},
};
</script>

<!-- Style -->
<style>
</style>